import { createAuth } from '@spotify-internal/oauth-silent-authentication';

import { CHAT_BOT_CLIENT_ID, SUPPORT_SITE_CLIENT_ID } from 'utils/config';

const auth = createAuth({
  clientId: SUPPORT_SITE_CLIENT_ID,
  scopes: ['user-read-email', 'user-read-private', 'user-close-account'],
});

export const getWebApiToken = async (): Promise<[string, number]> => {
  // Will raise if a user is not logged in
  return await auth.tokenProvider();
};

/* Distinguished so that Mayday can differentiate calls from the LivePerson bot vs Support Site */
const chatBotAuth = createAuth({
  clientId: CHAT_BOT_CLIENT_ID,
  scopes: ['chat-bot', 'user-close-account'],
});

/*
  Within a LivePerson chat, the chatbot will take actions on behalf of a user. These actions require auth tokens.
  From that environment, they do not have access to seeing if a user is logged in or not, so we are passing in a
  token if they already are. This prevents the chatbot's need for going through oauth again.
*/
export const getChatbotAuthToken = async (): Promise<string | undefined> => {
  try {
    // Will raise if a user is not logged in
    const [token] = await chatBotAuth.tokenProvider();
    return token;
  } catch (e) {
    return undefined;
  }
};

export default auth;
